import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, renderList as _renderList, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  style: {"width":"400px"},
  class: "d-flex justify-center"
}
const _hoisted_2 = {
  style: {"width":"400px"},
  class: "d-flex justify-center"
}
const _hoisted_3 = { style: {"height":"calc(100vh - 157px)","overflow-y":"auto","border-top-left-radius":"25px","border-top-right-radius":"25px"} }
const _hoisted_4 = { class: "pa-3" }
const _hoisted_5 = { class: "pl-4" }
const _hoisted_6 = { class: "pl-4" }
const _hoisted_7 = {
  key: 0,
  cols: "auto",
  class: "text-end"
}
const _hoisted_8 = {
  key: 1,
  cols: "auto",
  class: "text-end"
}
const _hoisted_9 = {
  key: 2,
  cols: "auto"
}
const _hoisted_10 = {
  key: 3,
  style: {"border-left":"1px solid #dddddd"},
  class: "text-left"
}
const _hoisted_11 = {
  key: 4,
  style: {"border-left":"1px solid #dddddd"},
  class: "text-left"
}
const _hoisted_12 = {
  key: 5,
  style: {"border-left":"1px solid #dddddd"},
  class: "text-left"
}
const _hoisted_13 = {
  key: 6,
  style: {"border-left":"1px solid #dddddd","width":"100px"},
  class: "text-center"
}
const _hoisted_14 = {
  key: 7,
  style: {"border-left":"1px solid #dddddd","width":"100px"},
  class: "text-center"
}
const _hoisted_15 = {
  key: 8,
  class: "text-center",
  style: {"border-left":"1px solid #dddddd","width":"100px"}
}
const _hoisted_16 = {
  key: 9,
  class: "text-center",
  style: {"border-left":"1px solid #dddddd","width":"100px"}
}
const _hoisted_17 = {
  key: 10,
  style: {"border-left":"1px solid #dddddd","width":"170px"},
  class: "text-right"
}
const _hoisted_18 = {
  key: 11,
  style: {"border-left":"1px solid #dddddd","width":"170px"},
  class: "text-right"
}
const _hoisted_19 = {
  key: 12,
  style: {"border-left":"1px solid #dddddd","width":"170px"},
  class: "text-right"
}
const _hoisted_20 = {
  key: 13,
  style: {"border-left":"1px solid #dddddd","width":"170px"},
  class: "text-right"
}
const _hoisted_21 = {
  key: 14,
  style: {"border-left":"1px solid #dddddd","width":"170px"},
  class: "text-right py-2;"
}
const _hoisted_22 = {
  key: 15,
  style: {"border-left":"1px solid #dddddd","width":"170px"},
  class: "text-right py-2;"
}
const _hoisted_23 = {
  key: 16,
  style: {"border-left":"1px solid #dddddd","width":"170px"},
  class: "text-right"
}
const _hoisted_24 = {
  key: 17,
  style: {"border-left":"1px solid #dddddd","width":"170px"},
  class: "text-right"
}
const _hoisted_25 = {
  key: 18,
  style: {"border-left":"1px solid #dddddd","width":"170px"},
  class: "text-center"
}
const _hoisted_26 = {
  key: 19,
  class: "text-center"
}
const _hoisted_27 = {
  key: 20,
  style: {"width":"68.75px"}
}
const _hoisted_28 = ["colspan"]
const _hoisted_29 = ["colspan"]
const _hoisted_30 = { class: "pl-4" }
const _hoisted_31 = { style: {"border":"1px solid #c4c4c4"} }
const _hoisted_32 = { style: {"background-color":"#f8f8f8"} }
const _hoisted_33 = {
  width: "30%",
  class: "pl-4"
}
const _hoisted_34 = {
  key: 0,
  width: "20%",
  class: "text-right"
}
const _hoisted_35 = {
  key: 1,
  width: "20%",
  class: "text-right"
}
const _hoisted_36 = {
  key: 2,
  width: "20%",
  class: "text-right"
}
const _hoisted_37 = {
  key: 3,
  width: "20%"
}
const _hoisted_38 = {
  key: 4,
  width: "20%"
}
const _hoisted_39 = {
  key: 5,
  width: "20%"
}
const _hoisted_40 = { style: {"background-color":"#f8f8f8"} }
const _hoisted_41 = {
  width: "30%",
  class: "pl-4"
}
const _hoisted_42 = {
  key: 0,
  width: "20%",
  class: "text-right"
}
const _hoisted_43 = {
  key: 1,
  width: "20%",
  class: "text-right"
}
const _hoisted_44 = {
  key: 0,
  width: "20%",
  class: "text-start"
}
const _hoisted_45 = {
  key: 1,
  width: "20%",
  class: "text-start"
}
const _hoisted_46 = {
  key: 2,
  width: "20%",
  class: "text-start"
}
const _hoisted_47 = {
  key: 3,
  width: "20%",
  class: "text-center"
}
const _hoisted_48 = {
  key: 0,
  style: {"background-color":"#f8f8f8"}
}
const _hoisted_49 = {
  width: "30%",
  class: "pl-4"
}
const _hoisted_50 = {
  key: 0,
  width: "20%",
  class: "text-right"
}
const _hoisted_51 = {
  key: 1,
  width: "20%",
  class: "text-right"
}
const _hoisted_52 = {
  key: 2,
  width: "50%",
  class: "text-start",
  colspan: "3"
}
const _hoisted_53 = {
  key: 3,
  width: "20%",
  class: "text-start",
  colspan: "3"
}
const _hoisted_54 = {
  key: 1,
  style: {"background-color":"#f8f8f8"}
}
const _hoisted_55 = {
  width: "30%",
  class: "pl-4"
}
const _hoisted_56 = {
  width: "20%",
  class: "text-right"
}
const _hoisted_57 = { key: 0 }
const _hoisted_58 = {
  width: "30%",
  class: "pl-8"
}
const _hoisted_59 = {
  width: "20%",
  class: "text-right"
}
const _hoisted_60 = { width: "20%" }
const _hoisted_61 = {
  width: "10%",
  class: "text-right"
}
const _hoisted_62 = { key: 1 }
const _hoisted_63 = {
  key: 0,
  width: "30%",
  class: "pl-8"
}
const _hoisted_64 = {
  key: 1,
  width: "30%",
  class: "pl-8"
}
const _hoisted_65 = {
  width: "20%",
  class: "text-right"
}
const _hoisted_66 = {
  width: "20%",
  class: "text-left"
}
const _hoisted_67 = {
  width: "10%",
  class: "text-right"
}
const _hoisted_68 = { key: 2 }
const _hoisted_69 = {
  width: "20%",
  class: "text-right"
}
const _hoisted_70 = { width: "20%" }
const _hoisted_71 = {
  width: "10%",
  class: "text-right"
}
const _hoisted_72 = { style: {"background-color":"#f8f8f8"} }
const _hoisted_73 = {
  width: "30%",
  class: "pl-4"
}
const _hoisted_74 = {
  width: "10%",
  class: "text-right"
}
const _hoisted_75 = {
  width: "20%",
  class: "pr-4 text-right"
}
const _hoisted_76 = {
  width: "20%",
  class: "text-right"
}
const _hoisted_77 = { width: "20%" }
const _hoisted_78 = {
  width: "20%",
  class: "text-right pr-4;"
}
const _hoisted_79 = {
  key: 2,
  class: "font-weight-bold"
}
const _hoisted_80 = { width: "20%" }
const _hoisted_81 = {
  width: "20%",
  class: "text-right pr-4;"
}
const _hoisted_82 = {
  width: "30%",
  class: "pl-8"
}
const _hoisted_83 = {
  width: "10%",
  class: "text-right"
}
const _hoisted_84 = {
  key: 0,
  width: "20%",
  class: "text-right pr-4 py-2;"
}
const _hoisted_85 = {
  key: 1,
  width: "20%",
  class: "text-right pr-4 py-2;"
}
const _hoisted_86 = {
  key: 2,
  width: "20%",
  class: "text-right pr-4 py-2;"
}
const _hoisted_87 = {
  width: "30%",
  class: "pl-8"
}
const _hoisted_88 = {
  width: "10%",
  class: "text-right"
}
const _hoisted_89 = {
  key: 0,
  width: "20%",
  class: "text-right py-2;"
}
const _hoisted_90 = {
  key: 1,
  width: "20%",
  class: "text-right py-2;"
}
const _hoisted_91 = {
  key: 2,
  width: "20%",
  class: "text-right py-2;"
}
const _hoisted_92 = {
  width: "30%",
  class: "pl-8"
}
const _hoisted_93 = {
  width: "10%",
  class: "text-right"
}
const _hoisted_94 = {
  key: 0,
  width: "20%",
  class: "text-right pr-4 py-2;"
}
const _hoisted_95 = {
  key: 1,
  width: "20%",
  class: "text-right pr-4 py-2;"
}
const _hoisted_96 = {
  key: 2,
  width: "20%",
  class: "text-right pr-4 py-2;"
}
const _hoisted_97 = { style: {"background-color":"#f8f8f8"} }
const _hoisted_98 = {
  key: 0,
  width: "30%",
  class: "pl-4"
}
const _hoisted_99 = {
  key: 1,
  width: "30%",
  class: "pl-4"
}
const _hoisted_100 = {
  width: "10%",
  class: "text-right"
}
const _hoisted_101 = {
  width: "20%",
  class: "text-right pr-4"
}
const _hoisted_102 = { class: "pl-4" }
const _hoisted_103 = { class: "text-uppercase pb-1" }
const _hoisted_104 = { class: "mb-0" }
const _hoisted_105 = { "no-gutters": "" }
const _hoisted_106 = { "no-gutters": "" }
const _hoisted_107 = { class: "pl-4" }
const _hoisted_108 = ["innerHTML"]
const _hoisted_109 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_back = _resolveComponent("v-btn-back")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn_prev = _resolveComponent("v-btn-prev")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn_warning = _resolveComponent("v-btn-warning")!
  const _component_TaxFormReadOnly = _resolveComponent("TaxFormReadOnly")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_AccountingTable = _resolveComponent("AccountingTable")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_oss_text_field = _resolveComponent("oss-text-field")!
  const _component_v_textarea_filled = _resolveComponent("v-textarea-filled")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_AuditConnectedAcrDocuments = _resolveComponent("AuditConnectedAcrDocuments")!
  const _component_AuditConnectedAcrResults = _resolveComponent("AuditConnectedAcrResults")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_GeneralLedger = _resolveComponent("GeneralLedger")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_UsersActivitiesHistory = _resolveComponent("UsersActivitiesHistory")!
  const _component_AuditDeleteAuditCheckResultDialog = _resolveComponent("AuditDeleteAuditCheckResultDialog")!
  const _component_Chat = _resolveComponent("Chat")!
  const _component_AuditCheckDocumentsManager = _resolveComponent("AuditCheckDocumentsManager")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "grid-list-md": "",
    fluid: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { class: "d-flex justify-space-between mb-1" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "6",
            class: "d-flex flex-column"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, { "no-gutters": "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "1",
                    class: "d-flex align-center justify-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn_back, {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'auditReport' })))
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "11" }, {
                    default: _withCtx(() => [
                      _createElementVNode("h2", null, _toDisplayString(_ctx.$t("audit." + _ctx.key + ".corporateTaxCalculation")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, { "no-gutters": "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "1" }),
                  _createVNode(_component_v_col, { cols: "10" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(`Statut : ${_ctx.checkStatus}`), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { cols: "6" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "d-flex justify-end align-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_tooltip, {
                    location: "bottom",
                    text: "Lier un document"
                  }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn, _mergeProps({
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialogAuditCheckDocumentsManager = true))
                      }, props, {
                        size: "x-small",
                        icon: "$oss-upload",
                        class: "mx-1"
                      }), null, 16)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_tooltip, {
                    location: "bottom",
                    text: "Message"
                  }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn, _mergeProps({
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openChat = !_ctx.openChat))
                      }, props, {
                        size: "x-small",
                        icon: "$oss-chat",
                        class: "mx-1"
                      }), null, 16)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_btn, {
                    disabled: 
                            _ctx.closedPeriod ||
                            _ctx.auditItems.validated ||
                            _ctx.loading ||
                            _ctx.dataLoading ||
                            !_ctx.accountingPeriod
                        ,
                    onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.storeReinstatementsAndDeductions()), ["stop"])),
                    size: "small",
                    class: "mx-1"
                  }, {
                    default: _withCtx(() => _cache[76] || (_cache[76] = [
                      _createTextVNode(" Enregistrer ")
                    ])),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_component_v_btn, {
                    rounded: "",
                    disabled: 
                            _ctx.disabledBtnGlobalValidation ||
                            _ctx.loading ||
                            _ctx.dataLoading ||
                            !_ctx.accountingPeriod
                        ,
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.validateFunction())),
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.auditItems.validated ? "Invalider" : "Valider"), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  (_ctx.isEnableReview)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _cache[77] || (_cache[77] = _createElementVNode("div", { style: {"border-right":"2px solid black","width":"2px","height":"25px","margin":"0 4px"} }, null, -1)),
                        _createVNode(_component_v_icon, {
                          disabled: 
                                _ctx.reviewed === 1 ||
                                !_ctx.isEnableReview ||
                                !_ctx.auditItems.validated ||
                                _ctx.loading ||
                                _ctx.dataLoading
                            ,
                          size: "small",
                          icon: "$fa-thumbs-up",
                          color: "primary",
                          class: "mx-1",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => {
                                _ctx.reviewed = 1;
                                _ctx.storeReinstatementsAndDeductions('REVIEW');
                            })
                        }, null, 8, ["disabled"]),
                        _createVNode(_component_v_icon, {
                          disabled: 
                                _ctx.reviewed === -1 ||
                                !_ctx.isEnableReview ||
                                !_ctx.auditItems.validated ||
                                _ctx.loading ||
                                _ctx.dataLoading
                            ,
                          size: "small",
                          icon: "$fa-thumbs-down",
                          color: "primary",
                          class: "mx-1",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => {
                                _ctx.reviewed = -1;
                                _ctx.storeReinstatementsAndDeductions('REVIEW');
                            })
                        }, null, 8, ["disabled"]),
                        _cache[78] || (_cache[78] = _createElementVNode("div", { style: {"border-right":"2px solid black","width":"1px","height":"25px","margin":"0 4px"} }, null, -1))
                      ], 64))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_tooltip, { location: "bottom" }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn_prev, _mergeProps(props, {
                        disabled: !_ctx.previousControl,
                        onClick: _cache[7] || (_cache[7] = ($event: any) => {
                                    _ctx.reviewed = 0;
                                    _ctx.openChat = false;
                                    _ctx.goToPreviousControl();
                                })
                      }), null, 16, ["disabled"])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, " Contrôle précédent : " + _toDisplayString(_ctx.previousControl && _ctx.previousControl.title
                                    ? _ctx.previousControl.title
                                    : ""), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_tooltip, { location: "bottom" }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn_next, _mergeProps(props, {
                        onClick: _cache[8] || (_cache[8] = ($event: any) => {
                                    _ctx.reviewed = 0;
                                    _ctx.openChat = false;
                                    _ctx.goToNextControl();
                                }),
                        disabled: !_ctx.nextControl
                      }), null, 16, ["disabled"])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, " Contrôle suivant : " + _toDisplayString(_ctx.nextControl && _ctx.nextControl.title ? _ctx.nextControl.title : ""), 1)
                    ]),
                    _: 1
                  }),
                  _cache[85] || (_cache[85] = _createElementVNode("div", { style: {"border-right":"2px solid black","width":"1px","height":"25px","margin":"0 4px"} }, null, -1)),
                  _createVNode(_component_v_menu, { "offset-y": "" }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn_icon, _mergeProps({ icon: "$dots_vertical" }, props, {
                        class: "mx-1",
                        color: "secondary"
                      }), null, 16)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_list, { nav: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item, {
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.displayActivityDialog = true))
                          }, {
                            append: _withCtx(() => [
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => _cache[80] || (_cache[80] = [
                                  _createTextVNode("$oss-activity")
                                ])),
                                _: 1
                              })
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => _cache[79] || (_cache[79] = [
                                  _createTextVNode("Afficher l'activité")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          (!_ctx.showDeleteAcrBtnIfRecovery)
                            ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                key: 0,
                                location: "bottom"
                              }, {
                                activator: _withCtx(({ props }) => [
                                  _createElementVNode("div", _mergeProps({ "no-gutters": "" }, props), [
                                    _createVNode(_component_v_list_item, {
                                      "no-gutters": "",
                                      disabled: ""
                                    }, {
                                      append: _withCtx(() => [
                                        _createVNode(_component_v_icon, { size: "small" }, {
                                          default: _withCtx(() => _cache[82] || (_cache[82] = [
                                            _createTextVNode(" $oss-trash ")
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_list_item_title, null, {
                                          default: _withCtx(() => _cache[81] || (_cache[81] = [
                                            _createTextVNode(" Supprimer le contrôle ")
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ], 16)
                                ]),
                                default: _withCtx(() => [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.showDeleteAcrBtnTooltipMessage), 1)
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createBlock(_component_v_list_item, {
                                key: 1,
                                "no-gutters": "",
                                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.deleteAuditCheckResultDialog = true))
                              }, {
                                append: _withCtx(() => [
                                  _createVNode(_component_v_icon, null, {
                                    default: _withCtx(() => _cache[84] || (_cache[84] = [
                                      _createTextVNode("$oss-trash")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => _cache[83] || (_cache[83] = [
                                      _createTextVNode(" Supprimer le contrôle ")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.loading || _ctx.dataLoading)
          ? (_openBlock(), _createBlock(_component_v_card, {
              key: 0,
              elevation: "0",
              style: {"background-color":"#ffffff","border-radius":"25px","margin-top":"10px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "pa-4 d-flex justify-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_progress_circular, {
                      indeterminate: "",
                      class: "mr-3"
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : (!_ctx.accountingPeriod)
            ? (_openBlock(), _createBlock(_component_v_row, {
                key: 1,
                "no-gutters": "",
                class: "d-flex flex-column justify-center align-center mb-3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    class: "mr-2 mb-1",
                    color: "red",
                    size: "large"
                  }, {
                    default: _withCtx(() => _cache[86] || (_cache[86] = [
                      _createTextVNode(" $oss-warning ")
                    ])),
                    _: 1
                  }),
                  _cache[87] || (_cache[87] = _createElementVNode("h3", null, "Aucune période sélectionnée", -1))
                ]),
                _: 1
              }))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                (_ctx.closedPeriod)
                  ? (_openBlock(), _createBlock(_component_v_row, {
                      key: 0,
                      "no-gutters": "",
                      class: "d-flex flex-column justify-center align-center mb-3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          class: "mr-2 mb-1",
                          size: "large"
                        }, {
                          default: _withCtx(() => _cache[88] || (_cache[88] = [
                            _createTextVNode(" $oss-warning ")
                          ])),
                          _: 1
                        }),
                        _cache[89] || (_cache[89] = _createElementVNode("h3", null, "Période clôturée", -1))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.bundleSheetId)
                  ? (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
                      default: _withCtx(() => [
                        (
                            _ctx.auditItems &&
                            _ctx.auditItems.bundleSheetToRegenerate &&
                            _ctx.auditItems.bundleErrorMessage &&
                            _ctx.auditItems.bundleErrorMessage.message
                        )
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createVNode(_component_v_spacer),
                              _createVNode(_component_v_col, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_btn_warning, {
                                    size: "x-small",
                                    color: "red",
                                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.regenerateBundleDialog = true))
                                  })
                                ]),
                                _: 1
                              })
                            ], 64))
                          : (_openBlock(), _createBlock(_component_v_col, { key: 1 }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_4, [
                                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, {
                                        cols: "12",
                                        class: "d-flex align-center"
                                      }, {
                                        default: _withCtx(() => [
                                          _cache[91] || (_cache[91] = _createElementVNode("p", { class: "px-4 py-0 ma-0" }, " La liasse est ici affichée en lecture seule. ", -1)),
                                          _createVNode(_component_v_btn, {
                                            class: "px-4",
                                            rounded: "",
                                            color: "primary",
                                            onClick: _cache[12] || (_cache[12] = ($event: any) => (
                                            _ctx.$router.push({
                                                name: 'taxForm2',
                                                params: { id: _ctx.auditItems.bundle.id },
                                            })
                                        )),
                                            size: "small"
                                          }, {
                                            default: _withCtx(() => _cache[90] || (_cache[90] = [
                                              _createTextVNode(" Liasse ")
                                            ])),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _createVNode(_component_TaxFormReadOnly, { id: _ctx.bundleSheetId }, null, 8, ["id"])
                              ]),
                              _: 1
                            }))
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      (_ctx.auditItems && _ctx.accountingPeriod && !_ctx.accountingPeriod.closed)
                        ? (_openBlock(), _createBlock(_component_v_icon, {
                            key: 0,
                            size: "x-small",
                            color: "red",
                            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.generateNewBundleDialog = true)),
                            icon: "$oss-warning"
                          }))
                        : (_ctx.accountingPeriod.closed)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createVNode(_component_v_card, {
                                elevation: "0",
                                style: {"background-color":"white","border-radius":"25px"},
                                class: "pa-6 mt-4"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, {
                                        cols: "auto",
                                        class: "ma-auto"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_row, { "no-gutters": "" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_col, { cols: "12" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                                                    default: _withCtx(() => [
                                                      _createElementVNode("h5", _hoisted_5, [
                                                        _createTextVNode(_toDisplayString(_ctx.$t("audit." + _ctx.key + ".incomeStatement")) + " - ", 1),
                                                        (
                                                            _ctx.auditItems.resultBeforeReintegrationsDeductionsAnd695 &&
                                                            _ctx.auditItems.resultBeforeReintegrationsDeductionsAnd695 <
                                                                0
                                                        )
                                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                              _createTextVNode(" Bénéfice comptable avant réintégrations, déductions et impôts : ")
                                                            ], 64))
                                                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                              _createTextVNode(" Perte comptable avant réintégrations, déductions et impôts : ")
                                                            ], 64)),
                                                        _createTextVNode(" " + _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            Math.abs(
                                                                _ctx.auditItems.resultBeforeReintegrationsDeductionsAnd695,
                                                            ),
                                                            undefined,
                                                        )), 1)
                                                      ])
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_row, { "no-gutters": "" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_col, { cols: "12" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_card_subtitle, null, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(" dont Résultat comptable : " + _toDisplayString(_ctx.newCommonFormatCurrency(-_ctx.netResultAmount)) + " + IS déjà comptabilisé en c/695 : " + _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.booked695Amount)), 1)
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_spacer),
                                      _createVNode(_component_v_col, {
                                        cols: "1",
                                        class: "d-flex align-center px-0 justify-center"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_row, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_col, {
                                                cols: "6",
                                                class: "align-center"
                                              }),
                                              _createVNode(_component_v_col, {
                                                cols: "6",
                                                class: "align-center"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_btn_icon, {
                                                    icon: 
                                                    _ctx.showIncomeStatement
                                                        ? '$fa-chevron-up'
                                                        : '$fa-chevron-down'
                                                ,
                                                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.showIncomeStatement = !_ctx.showIncomeStatement))
                                                  }, null, 8, ["icon"])
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_expand_transition, null, {
                                    default: _withCtx(() => [
                                      _withDirectives(_createElementVNode("div", null, [
                                        _createVNode(_component_v_card_text, { class: "pt-2 pb-0" }, {
                                          default: _withCtx(() => [
                                            (_ctx.periodsAccountingTable)
                                              ? (_openBlock(), _createBlock(_component_AccountingTable, {
                                                  options: {
                                                title: 'Compte de résultat',
                                                className: 'INCOME_STATEMENT',
                                            },
                                                  periods: _ctx.periodsAccountingTable,
                                                  tags: [],
                                                  onTable: _cache[15] || (_cache[15] = ($event: any) => (_ctx.fetchResult($event))),
                                                  key: _ctx.refreshAccountingTable
                                                }, null, 8, ["periods"]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 1
                                        })
                                      ], 512), [
                                        [_vShow, _ctx.showIncomeStatement]
                                      ])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_card, {
                                elevation: "0",
                                style: {"background-color":"white","border-radius":"25px"},
                                class: "pa-6 mt-4"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, {
                                        cols: "auto",
                                        class: "ma-auto"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("h5", _hoisted_6, _toDisplayString(_ctx.$t("audit." + _ctx.key + ".analysisElements")), 1)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_spacer),
                                      _createVNode(_component_v_col, {
                                        cols: "1",
                                        class: "d-flex align-center px-0 justify-center"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_row, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_col, {
                                                cols: "6",
                                                class: "d-flex align-center"
                                              }, {
                                                default: _withCtx(() => [
                                                  (_ctx.auditItems.validatedTable)
                                                    ? (_openBlock(), _createBlock(_component_v_icon, {
                                                        key: 0,
                                                        color: "primary",
                                                        icon: "$check_circle",
                                                        size: "large"
                                                      }))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_col, {
                                                cols: "6",
                                                "data-cy": "CheckCorporateTax-checkCircle"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_btn_icon, {
                                                    icon: 
                                                    _ctx.showTable
                                                        ? '$fa-chevron-up'
                                                        : '$fa-chevron-down'
                                                ,
                                                    onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.showTable = !_ctx.showTable))
                                                  }, null, 8, ["icon"])
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_expand_transition, null, {
                                    default: _withCtx(() => [
                                      _withDirectives(_createElementVNode("div", null, [
                                        (_ctx.adjustmentTable)
                                          ? (_openBlock(), _createBlock(_component_v_card_text, {
                                              key: 0,
                                              class: "pt-2 pb-0"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_data_table, {
                                                  headers: _ctx.auditItems.adjustmentTableHeaders,
                                                  items: _ctx.adjustmentTable,
                                                  expanded: _ctx.expanded,
                                                  "item-key": "tableBlock",
                                                  "show-expand": "",
                                                  loading: _ctx.loading,
                                                  class: "table",
                                                  style: {"border":"1px #ededed solid"},
                                                  "fixed-header": "",
                                                  "hide-default-footer": "",
                                                  "items-per-page": -1
                                                }, {
                                                  "no-data": _withCtx(() => _cache[92] || (_cache[92] = [
                                                    _createTextVNode("Aucune charge à réintégrer")
                                                  ])),
                                                  item: _withCtx((props) => [
                                                    _createElementVNode("tr", {
                                                      style: _normalizeStyle(props.item.style)
                                                    }, [
                                                      (
                                                            props.item.accountableAccounts
                                                                .length === 1
                                                        )
                                                        ? (_openBlock(), _createElementBlock("td", _hoisted_7, _toDisplayString(props.item.accountableAccounts[0]), 1))
                                                        : (
                                                            props.item.accountableAccounts.length >=
                                                            1
                                                        )
                                                          ? (_openBlock(), _createElementBlock("td", _hoisted_8, _toDisplayString(_ctx.accountableAccountNames(
                                                                props.item.accountableAccounts,
                                                            )), 1))
                                                          : (_openBlock(), _createElementBlock("td", _hoisted_9)),
                                                      (props.item.tableBlock)
                                                        ? (_openBlock(), _createElementBlock("td", _hoisted_10, [
                                                            (
                                                                [
                                                                    'preTaxProfitOrLoss',
                                                                    'taxableTaxResult',
                                                                ].includes(props.item.tableBlock)
                                                            )
                                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                  _createTextVNode(_toDisplayString(props.item.wording), 1)
                                                                ], 64))
                                                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                  _createTextVNode(_toDisplayString(_ctx.$t(
                                                                    "audit." +
                                                                        _ctx.key +
                                                                        "." +
                                                                        props.item.tableBlock,
                                                                )), 1)
                                                                ], 64))
                                                          ]))
                                                        : (props.item.wording)
                                                          ? (_openBlock(), _createElementBlock("td", _hoisted_11, _toDisplayString(props.item.wording), 1))
                                                          : (_openBlock(), _createElementBlock("td", _hoisted_12)),
                                                      (props.item.normalTaxSystem)
                                                        ? (_openBlock(), _createElementBlock("td", _hoisted_13, _toDisplayString(props.item.normalTaxSystem), 1))
                                                        : (_openBlock(), _createElementBlock("td", _hoisted_14)),
                                                      (props.item.bncTaxSystem)
                                                        ? (_openBlock(), _createElementBlock("td", _hoisted_15, _toDisplayString(props.item.bncTaxSystem), 1))
                                                        : (_openBlock(), _createElementBlock("td", _hoisted_16)),
                                                      (props.item.computedAmountSigned)
                                                        ? (_openBlock(), _createElementBlock("td", _hoisted_17, [
                                                            _createTextVNode(_toDisplayString(_ctx.newCommonFormatCurrency(
                                                                Math.abs(
                                                                    props.item.computedAmountSigned,
                                                                ),
                                                                { currency: "", DC: true },
                                                            )) + " ", 1),
                                                            (props.item.normalTaxSystem)
                                                              ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                                                                  key: 0,
                                                                  icon: "$remove_red_eye",
                                                                  onClick: _withModifiers(($event: any) => (_ctx.setDetailsList(props.item)), ["stop"])
                                                                }, null, 8, ["onClick"]))
                                                              : _createCommentVNode("", true)
                                                          ]))
                                                        : (
                                                            props.item.style ===
                                                            'background-color: #78c5c2; font-weight: bold;'
                                                        )
                                                          ? (_openBlock(), _createElementBlock("td", _hoisted_18, " - "))
                                                          : (
                                                            props.item.accountableAccounts
                                                                .length === 1
                                                        )
                                                            ? (_openBlock(), _createElementBlock("td", _hoisted_19, " 0 "))
                                                            : (_openBlock(), _createElementBlock("td", _hoisted_20)),
                                                      (
                                                            props.item.normalTaxSystem &&
                                                            _ctx.auditItems.validatedTable
                                                        )
                                                        ? (_openBlock(), _createElementBlock("td", _hoisted_21, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                Math.abs(
                                                                    props.item.manualAmountSigned,
                                                                ),
                                                                { currency: "", DC: true },
                                                            )), 1))
                                                        : (props.item.normalTaxSystem)
                                                          ? (_openBlock(), _createElementBlock("td", _hoisted_22, [
                                                              _createVNode(_component_oss_text_field, {
                                                                outlined: "",
                                                                dense: "",
                                                                "hide-details": "",
                                                                modelValue: props.item.manualAmountSigned,
                                                                "onUpdate:modelValue": [
                                                                  ($event: any) => ((props.item.manualAmountSigned) = $event),
                                                                  _cache[17] || (_cache[17] = ($event: any) => (_ctx.changeAmounts()))
                                                                ],
                                                                style: {"width":"170px"},
                                                                onClick: _cache[18] || (_cache[18] = _withModifiers(() => {}, ["stop"]))
                                                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                            ]))
                                                          : (props.item.manualAmountSigned)
                                                            ? (_openBlock(), _createElementBlock("td", _hoisted_23, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                Math.abs(
                                                                    props.item.manualAmountSigned,
                                                                ),
                                                                { currency: "", DC: true },
                                                            )), 1))
                                                            : (
                                                            props.item.style ===
                                                            'background-color: #f8f8f8'
                                                        )
                                                              ? (_openBlock(), _createElementBlock("td", _hoisted_24, " 0,00 € "))
                                                              : (_openBlock(), _createElementBlock("td", _hoisted_25)),
                                                      (props.item.normalTaxSystem)
                                                        ? (_openBlock(), _createElementBlock("td", _hoisted_26, [
                                                            (_ctx.closedPeriod)
                                                              ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                                                                  key: 0,
                                                                  icon: "$comment ",
                                                                  dense: "",
                                                                  color: "primary",
                                                                  elevation: "0",
                                                                  disabled: "",
                                                                  size: "small"
                                                                }))
                                                              : (_openBlock(), _createBlock(_component_v_btn_icon, {
                                                                  key: 1,
                                                                  icon: "\n                                                                $comment\n\n                                                                $comment\n                                                            ",
                                                                  dense: "",
                                                                  color: "primary",
                                                                  elevation: "0",
                                                                  onClick: ($event: any) => (
                                                                _ctx.addAdjustmentTableExpand(props.item)
                                                            ),
                                                                  size: "small"
                                                                }, null, 8, ["onClick"]))
                                                          ]))
                                                        : (_openBlock(), _createElementBlock("td", _hoisted_27))
                                                    ], 4)
                                                  ]),
                                                  "expanded-row": _withCtx(({ columns, item }) => [
                                                    (
                                                        !!item.comment &&
                                                        (_ctx.closedPeriod || _ctx.auditItems.validated)
                                                    )
                                                      ? (_openBlock(), _createElementBlock("td", {
                                                          key: 0,
                                                          colspan: columns.length,
                                                          style: {"height":"120px","padding-top":"0","margin-top":"0"}
                                                        }, [
                                                          _createVNode(_component_v_textarea_filled, {
                                                            outlined: "",
                                                            "hide-details": "",
                                                            dense: "",
                                                            modelValue: item.comment,
                                                            "onUpdate:modelValue": ($event: any) => ((item.comment) = $event),
                                                            style: {"margin-right":"auto","margin-left":"auto","padding":"10px","border":"1px #ededed solid"},
                                                            disabled: ""
                                                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                        ], 8, _hoisted_28))
                                                      : (!!item.displayComment)
                                                        ? (_openBlock(), _createElementBlock("td", {
                                                            key: 1,
                                                            colspan: columns.length,
                                                            style: {"height":"120px","padding-top":"0","margin-top":"0"}
                                                          }, [
                                                            _createVNode(_component_v_textarea_filled, {
                                                              outlined: "",
                                                              "hide-details": "",
                                                              dense: "",
                                                              modelValue: item.comment,
                                                              "onUpdate:modelValue": [($event: any) => ((item.comment) = $event), ($event: any) => (_ctx.addComment(item))],
                                                              style: {"margin-right":"auto","margin-left":"auto","padding":"10px","border":"1px #ededed solid"}
                                                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                          ], 8, _hoisted_29))
                                                        : _createCommentVNode("", true)
                                                  ]),
                                                  _: 1
                                                }, 8, ["headers", "items", "expanded", "loading"]),
                                                _createVNode(_component_v_row, {
                                                  "no-gutters": "",
                                                  class: "text-right pt-4"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_spacer),
                                                    _createVNode(_component_v_col, {
                                                      cols: "auto",
                                                      class: "text-right pr-4"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_btn, {
                                                          disabled: _ctx.closedPeriod || _ctx.auditItems.validated,
                                                          dense: "",
                                                          rounded: "",
                                                          elevation: "0",
                                                          onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.storeReinstatementsAndDeductions())),
                                                          size: "small"
                                                        }, {
                                                          default: _withCtx(() => _cache[93] || (_cache[93] = [
                                                            _createTextVNode(" Enregistrer ")
                                                          ])),
                                                          _: 1
                                                        }, 8, ["disabled"])
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_v_col, {
                                                      cols: "auto",
                                                      class: "text-right"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        (!_ctx.auditItems.validatedTable)
                                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                                              key: 0,
                                                              disabled: _ctx.closedPeriod || _ctx.auditItems.validated,
                                                              dense: "",
                                                              rounded: "",
                                                              elevation: "0",
                                                              onClick: _cache[20] || (_cache[20] = ($event: any) => {
                                                        _ctx.auditItems.validatedTable = true;
                                                        _ctx.showTable = false;
                                                        _ctx.storeReinstatementsAndDeductions(
                                                            'VALIDATE',
                                                        );
                                                    }),
                                                              "data-cy": "CheckCorporateTax-valid",
                                                              size: "small"
                                                            }, {
                                                              default: _withCtx(() => _cache[94] || (_cache[94] = [
                                                                _createTextVNode(" Valider le résultat fiscal imposable ")
                                                              ])),
                                                              _: 1
                                                            }, 8, ["disabled"]))
                                                          : (_openBlock(), _createBlock(_component_v_btn, {
                                                              key: 1,
                                                              disabled: _ctx.closedPeriod || _ctx.auditItems.validated,
                                                              dense: "",
                                                              rounded: "",
                                                              elevation: "0",
                                                              onClick: _cache[21] || (_cache[21] = ($event: any) => {
                                                        _ctx.auditItems.validatedTable = false;
                                                        _ctx.storeReinstatementsAndDeductions('UPDATE');
                                                    }),
                                                              "data-cy": "CheckCorporateTax-unValid",
                                                              size: "small"
                                                            }, {
                                                              default: _withCtx(() => _cache[95] || (_cache[95] = [
                                                                _createTextVNode(" Invalider le résultat fiscal imposable ")
                                                              ])),
                                                              _: 1
                                                            }, 8, ["disabled"]))
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true)
                                      ], 512), [
                                        [_vShow, _ctx.showTable]
                                      ])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ], 64))
                          : _createCommentVNode("", true)
                    ], 64)),
                _createVNode(_component_v_card, { class: "audit-card" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "11",
                          class: "ma-auto"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                              default: _withCtx(() => [
                                _createElementVNode("h5", _hoisted_30, _toDisplayString(_ctx.$t("audit." + _ctx.key + ".corporateTaxCalculation")), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "1",
                          class: "d-flex align-center px-0 justify-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "align-center pa-0"
                                }, {
                                  default: _withCtx(() => [
                                    (_ctx.auditItems.validatedTax)
                                      ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                                          key: 0,
                                          icon: "$check_circle",
                                          style: {"width":"40px"},
                                          class: "d-inline px-2",
                                          color: "primary",
                                          size: "large",
                                          "data-cy": "CheckCorporateTax-checkCircle"
                                        }))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "align-center pa-0"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_btn_icon, {
                                      icon: !_ctx.openTax ? '$fa-chevron-up' : '$fa-chevron-down',
                                      onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.openTax())),
                                      style: {"width":"40px"},
                                      class: "d-inline px-2"
                                    }, null, 8, ["icon"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_expand_transition, null, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("div", null, [
                          _createVNode(_component_v_card_text, { class: "pt-2 pb-0" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_table, {
                                class: _normalizeClass(_ctx.table),
                                style: {"border":"1px #ededed solid"}
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("tbody", _hoisted_31, [
                                    _createElementVNode("tr", _hoisted_32, [
                                      _createElementVNode("td", _hoisted_33, [
                                        (_ctx.bundleSheetId && _ctx.bundleSheetId.length)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                              (_ctx.preTaxIncome < 0)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                    _createTextVNode(" BENEFICE FISCAL IMPOSABLE ")
                                                  ], 64))
                                                : (_ctx.preTaxIncome > 0)
                                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                      _createTextVNode(" DEFICIT FISCAL ")
                                                    ], 64))
                                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                      _createTextVNode(" RESULTAT FISCAL IMPOSABLE ")
                                                    ], 64))
                                            ], 64))
                                          : (
                                                        _ctx.adjustmentTable &&
                                                        _ctx.adjustmentTable[31] &&
                                                        _ctx.adjustmentTable[31].manualAmountSigned
                                                    )
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                (
                                                            _ctx.adjustmentTable[31].manualAmountSigned <
                                                            0
                                                        )
                                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                      _createTextVNode(" BENEFICE FISCAL IMPOSABLE ")
                                                    ], 64))
                                                  : (
                                                            _ctx.adjustmentTable[31].manualAmountSigned >
                                                            0
                                                        )
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                        _createTextVNode(" DEFICIT FISCAL ")
                                                      ], 64))
                                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                        _createTextVNode(" RESULTAT FISCAL IMPOSABLE ")
                                                      ], 64))
                                              ], 64))
                                            : _createCommentVNode("", true)
                                      ]),
                                      (_ctx.bundleSheetId && _ctx.bundleSheetId.length)
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_34, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            Math.abs(_ctx.preTaxIncome),
                                                        )), 1))
                                        : (_ctx.adjustmentTable && _ctx.adjustmentTable[31])
                                          ? (_openBlock(), _createElementBlock("td", _hoisted_35, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            Math.abs(
                                                                _ctx.adjustmentTable[31]
                                                                    .manualAmountSigned,
                                                            ),
                                                        )), 1))
                                          : (_openBlock(), _createElementBlock("td", _hoisted_36, "NAN")),
                                      (
                                                    _ctx.adjustmentTable &&
                                                    _ctx.adjustmentTable[31] &&
                                                    _ctx.adjustmentTable[31].manualAmountSigned &&
                                                    _ctx.adjustmentTable[31].manualAmountSigned >= 0
                                                )
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_37, " Pas d'impôt "))
                                        : (
                                                    _ctx.bundleSheetId &&
                                                    _ctx.bundleSheetId.length &&
                                                    _ctx.preTaxIncome >= 0
                                                )
                                          ? (_openBlock(), _createElementBlock("td", _hoisted_38, " Pas d'impôt "))
                                          : (_openBlock(), _createElementBlock("td", _hoisted_39)),
                                      _cache[96] || (_cache[96] = _createElementVNode("td", {
                                        width: "10%",
                                        class: "text-right"
                                      }, null, -1)),
                                      _cache[97] || (_cache[97] = _createElementVNode("td", {
                                        width: "20%",
                                        class: "pr-4"
                                      }, null, -1))
                                    ]),
                                    (
                                                (_ctx.bundleSheetId && _ctx.preTaxIncome) ||
                                                (_ctx.adjustmentTable &&
                                                    _ctx.adjustmentTable[31] &&
                                                    _ctx.adjustmentTable[31].manualAmountSigned < 0)
                                            )
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createElementVNode("tr", _hoisted_40, [
                                            _createElementVNode("td", _hoisted_41, _toDisplayString(_ctx.$t("audit." + _ctx.key + ".salesTurnover")), 1),
                                            (_ctx.auditItems.salesTurnover)
                                              ? (_openBlock(), _createElementBlock("td", _hoisted_42, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            Math.abs(_ctx.auditItems.salesTurnover),
                                                            { currency: "", DC: true },
                                                        )), 1))
                                              : (_openBlock(), _createElementBlock("td", _hoisted_43, "-")),
                                            (
                                                        _ctx.auditItems.turnoverLessThen &&
                                                        _ctx.auditItems.year
                                                    )
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                  (_ctx.periodTurnoverBracket0)
                                                    ? (_openBlock(), _createElementBlock("td", _hoisted_44, [
                                                        _createTextVNode(_toDisplayString("CA inférieur à " +
                                                            _ctx.newCommonFormatCurrency(
                                                                Math.abs(_ctx.periodTurnoverBracket0),
                                                                undefined,
                                                            )) + " ", 1),
                                                        (
                                                                _ctx.auditItems.periodMonthDuration != 12
                                                            )
                                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                              _createTextVNode(" (prorata de " + _toDisplayString(_ctx.auditItems.periodMonthDuration) + " mois de " + _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                    Math.abs(
                                                                        _ctx.fullPeriodTurnoverBracket0,
                                                                    ),
                                                                    undefined,
                                                                )) + ") ", 1)
                                                            ], 64))
                                                          : _createCommentVNode("", true)
                                                      ]))
                                                    : (
                                                            _ctx.auditItems.preTaxIncomeBrackets &&
                                                            _ctx.auditItems.preTaxIncomeBracket0
                                                        )
                                                      ? (_openBlock(), _createElementBlock("td", _hoisted_45, [
                                                          _createTextVNode(_toDisplayString("CA inférieur à " +
                                                            _ctx.newCommonFormatCurrency(
                                                                Math.abs(
                                                                    _ctx.auditItems.preTaxIncomeBracket0,
                                                                ),
                                                                undefined,
                                                            )) + " ", 1),
                                                          (
                                                                _ctx.auditItems.periodMonthDuration != 12
                                                            )
                                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                _createTextVNode(" (prorata de " + _toDisplayString(_ctx.auditItems.periodMonthDuration) + " mois de " + _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                    _ctx.fullPeriodTurnoverBracket0,
                                                                    undefined,
                                                                )) + ") ", 1)
                                                              ], 64))
                                                            : _createCommentVNode("", true)
                                                        ]))
                                                      : (_openBlock(), _createElementBlock("td", _hoisted_46, " CA > " + _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                _ctx.periodTurnoverBracket0,
                                                                undefined,
                                                            )), 1))
                                                ], 64))
                                              : (_openBlock(), _createElementBlock("td", _hoisted_47)),
                                            _cache[98] || (_cache[98] = _createElementVNode("td", {
                                              width: "10%",
                                              class: "text-right"
                                            }, null, -1)),
                                            _cache[99] || (_cache[99] = _createElementVNode("td", { width: "20%" }, null, -1))
                                          ]),
                                          (
                                                    _ctx.auditItems &&
                                                    _ctx.auditItems.turnoverLessThen &&
                                                    _ctx.auditItems.year &&
                                                    _ctx.periodTurnoverBracket0
                                                )
                                            ? (_openBlock(), _createElementBlock("tr", _hoisted_48, [
                                                _createElementVNode("td", _hoisted_49, " Capital social : " + _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            _ctx.auditItems.shareCapital,
                                                            { currency: "", DC: true },
                                                        )), 1),
                                                (_ctx.c101300)
                                                  ? (_openBlock(), _createElementBlock("td", _hoisted_50, " dont versé : " + _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.c101300, undefined)), 1))
                                                  : (_openBlock(), _createElementBlock("td", _hoisted_51, " Pas de capital versé ")),
                                                (_ctx.fullyPaidCapital)
                                                  ? (_openBlock(), _createElementBlock("td", _hoisted_52, " Entièrement versé "))
                                                  : (_openBlock(), _createElementBlock("td", _hoisted_53, " Le capital n'a pas été entièrement versé "))
                                              ]))
                                            : _createCommentVNode("", true),
                                          (
                                                    _ctx.auditItems &&
                                                    _ctx.auditItems.turnoverLessThen &&
                                                    _ctx.auditItems.year &&
                                                    _ctx.periodTurnoverBracket0
                                                )
                                            ? (_openBlock(), _createElementBlock("tr", _hoisted_54, [
                                                _createElementVNode("td", _hoisted_55, _toDisplayString(_ctx.$t(
                                                            "audit." +
                                                                _ctx.key +
                                                                ".naturalPersonsSharesRateOver75",
                                                        )), 1),
                                                _createElementVNode("td", _hoisted_56, [
                                                  _createVNode(_component_v_checkbox, {
                                                    disabled: _ctx.closedPeriod,
                                                    modelValue: _ctx.naturalPersonsSharesRateOver75,
                                                    "onUpdate:modelValue": [
                                                      _cache[23] || (_cache[23] = ($event: any) => ((_ctx.naturalPersonsSharesRateOver75) = $event)),
                                                      _cache[24] || (_cache[24] = ($event: any) => (_ctx.changeAmounts()))
                                                    ],
                                                    ripple: false,
                                                    class: "pa-0 d-flex justify-end"
                                                  }, null, 8, ["disabled", "modelValue"])
                                                ]),
                                                _cache[100] || (_cache[100] = _createElementVNode("td", { width: "20%" }, null, -1)),
                                                _cache[101] || (_cache[101] = _createElementVNode("td", {
                                                  width: "10%",
                                                  class: "text-right"
                                                }, null, -1)),
                                                _cache[102] || (_cache[102] = _createElementVNode("td", {
                                                  width: "20%",
                                                  class: "pr-4"
                                                }, null, -1))
                                              ]))
                                            : _createCommentVNode("", true)
                                        ], 64))
                                      : _createCommentVNode("", true),
                                    (_ctx.corporateTaxAmount)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          (
                                                    _ctx.customerCorporateTaxObject &&
                                                    _ctx.customerCorporateTaxObject.reduced &&
                                                    _ctx.customerCorporateTaxObject.reduced.taxBase &&
                                                    _ctx.customerCorporateTaxObject.reduced.taxRate &&
                                                    _ctx.customerCorporateTaxObject.reduced.taxAmount
                                                )
                                            ? (_openBlock(), _createElementBlock("tr", _hoisted_57, [
                                                _createElementVNode("td", _hoisted_58, [
                                                  _createTextVNode(" Taux réduit - bénéfice plafonné à " + _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            Math.abs(_ctx.periodPreTaxIncomeBracket0),
                                                            undefined,
                                                        )) + " ", 1),
                                                  (_ctx.auditItems.periodMonthDuration != 12)
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                        _createTextVNode(" (prorata de " + _toDisplayString(_ctx.auditItems.periodMonthDuration) + " mois de " + _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                Math.abs(
                                                                    _ctx.auditItems.preTaxIncomeBracket0,
                                                                ),
                                                                undefined,
                                                            )) + ") ", 1)
                                                      ], 64))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _createElementVNode("td", _hoisted_59, " Base : " + _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            Math.abs(
                                                                _ctx.customerCorporateTaxObject.reduced
                                                                    .taxBase,
                                                            ),
                                                            undefined,
                                                        )), 1),
                                                _createElementVNode("td", _hoisted_60, _toDisplayString(_ctx.customerCorporateTaxObject.reduced.taxRate) + "% ", 1),
                                                _createElementVNode("td", _hoisted_61, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            Math.abs(
                                                                _ctx.customerCorporateTaxObject.reduced
                                                                    .taxAmount,
                                                            ),
                                                            {},
                                                        )), 1),
                                                _cache[103] || (_cache[103] = _createElementVNode("td", {
                                                  width: "20%",
                                                  class: "pr-4"
                                                }, null, -1))
                                              ]))
                                            : _createCommentVNode("", true),
                                          (
                                                    _ctx.customerCorporateTaxObject &&
                                                    _ctx.customerCorporateTaxObject.normal &&
                                                    _ctx.customerCorporateTaxObject.normal.taxBase &&
                                                    _ctx.customerCorporateTaxObject.normal.taxRate &&
                                                    _ctx.customerCorporateTaxObject.normal.taxAmount
                                                )
                                            ? (_openBlock(), _createElementBlock("tr", _hoisted_62, [
                                                (_ctx.periodPreTaxIncomeBracket1)
                                                  ? (_openBlock(), _createElementBlock("td", _hoisted_63, [
                                                      _cache[104] || (_cache[104] = _createTextVNode(" Taux normal ")),
                                                      (_ctx.periodPreTaxIncomeBracket1 !== 0)
                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                            _createTextVNode(" - plafonné à " + _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                Math.abs(
                                                                    _ctx.periodPreTaxIncomeBracket1,
                                                                ),
                                                                undefined,
                                                            )) + " ", 1),
                                                            (
                                                                _ctx.auditItems.periodMonthDuration != 12
                                                            )
                                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                  _createTextVNode(" (prorata de " + _toDisplayString(_ctx.auditItems.periodMonthDuration) + " mois de " + _toDisplayString(_ctx.newCommonFormatCurrency(
                                                                    _ctx.auditItems.preTaxIncomeBracket1,
                                                                    undefined,
                                                                )) + ") ", 1)
                                                                ], 64))
                                                              : _createCommentVNode("", true)
                                                          ], 64))
                                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                            _createTextVNode(" (non plafonné) ")
                                                          ], 64))
                                                    ]))
                                                  : (_openBlock(), _createElementBlock("td", _hoisted_64, "Taux normal")),
                                                _createElementVNode("td", _hoisted_65, " Base : " + _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            Math.abs(
                                                                _ctx.customerCorporateTaxObject.normal
                                                                    .taxBase,
                                                            ),
                                                            undefined,
                                                        )), 1),
                                                _createElementVNode("td", _hoisted_66, _toDisplayString(_ctx.customerCorporateTaxObject.normal.taxRate) + "% ", 1),
                                                _createElementVNode("td", _hoisted_67, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            Math.abs(
                                                                _ctx.customerCorporateTaxObject.normal
                                                                    .taxAmount,
                                                            ),
                                                            undefined,
                                                        )), 1),
                                                _cache[105] || (_cache[105] = _createElementVNode("td", {
                                                  width: "20%",
                                                  class: "pr-4"
                                                }, null, -1))
                                              ]))
                                            : _createCommentVNode("", true),
                                          (
                                                    _ctx.customerCorporateTaxObject &&
                                                    _ctx.customerCorporateTaxObject.overrun &&
                                                    _ctx.customerCorporateTaxObject.overrun.taxBase &&
                                                    _ctx.customerCorporateTaxObject.overrun.taxRate &&
                                                    _ctx.customerCorporateTaxObject.overrun.taxAmount
                                                )
                                            ? (_openBlock(), _createElementBlock("tr", _hoisted_68, [
                                                _cache[106] || (_cache[106] = _createElementVNode("td", {
                                                  width: "30%",
                                                  class: "pl-8"
                                                }, "Taux majoré", -1)),
                                                _createElementVNode("td", _hoisted_69, " Base : " + _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            Math.abs(
                                                                _ctx.customerCorporateTaxObject.overrun
                                                                    .taxBase,
                                                            ),
                                                            undefined,
                                                        )), 1),
                                                _createElementVNode("td", _hoisted_70, _toDisplayString(_ctx.customerCorporateTaxObject.overrun.taxRate) + "% ", 1),
                                                _createElementVNode("td", _hoisted_71, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                            Math.abs(
                                                                _ctx.customerCorporateTaxObject.overrun
                                                                    .taxAmount,
                                                            ),
                                                            undefined,
                                                        )), 1),
                                                _cache[107] || (_cache[107] = _createElementVNode("td", {
                                                  width: "20%",
                                                  class: "pr-4"
                                                }, null, -1))
                                              ]))
                                            : _createCommentVNode("", true)
                                        ], 64))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("tr", _hoisted_72, [
                                      _createElementVNode("td", _hoisted_73, _toDisplayString(_ctx.$t("audit." + _ctx.key + ".corporateTax")), 1),
                                      _cache[109] || (_cache[109] = _createElementVNode("td", { width: "20%" }, null, -1)),
                                      _cache[110] || (_cache[110] = _createElementVNode("td", { width: "20%" }, null, -1)),
                                      _createElementVNode("td", _hoisted_74, [
                                        _createVNode(_component_v_btn_icon, {
                                          icon: " $oss-help",
                                          onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.corporateTaxSnackbar = true))
                                        }),
                                        _createVNode(_component_v_snackbar, {
                                          modelValue: _ctx.corporateTaxSnackbar,
                                          "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.corporateTaxSnackbar) = $event)),
                                          "min-width": "50vw"
                                        }, {
                                          actions: _withCtx(() => [
                                            _createVNode(_component_v_btn_icon, {
                                              icon: "$oss-close",
                                              size: "small",
                                              onClick: _cache[26] || (_cache[26] = _withModifiers(($event: any) => (
                                                                _ctx.corporateTaxSnackbar = false
                                                            ), ["stop"])),
                                              class: "white"
                                            })
                                          ]),
                                          default: _withCtx(() => [
                                            _cache[108] || (_cache[108] = _createElementVNode("h2", { class: "pb-2" }, " Total impôt dû : après eventuelle génération de l'écriture, doit correspondre aux soldes des comptes 695000 et 444000 ", -1))
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue"]),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customerCorporateTaxSentence(), (sentence, index) => {
                                          return (_openBlock(), _createElementBlock("div", { key: index }, [
                                            sentence
                                              ? (_openBlock(), _createBlock(_component_v_row, {
                                                  key: 0,
                                                  "no-gutters": "",
                                                  class: "py-0"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_col)
                                                  ]),
                                                  _: 1
                                                }))
                                              : _createCommentVNode("", true)
                                          ]))
                                        }), 128))
                                      ]),
                                      _createElementVNode("td", _hoisted_75, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                        _ctx.corporateTaxAmount,
                                                        undefined,
                                                    )), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _cache[111] || (_cache[111] = _createElementVNode("td", {
                                        width: "30%",
                                        class: "pl-8"
                                      }, " Solde actuel de la balance c/695, dont ", -1)),
                                      _createElementVNode("td", _hoisted_76, " OD manuelle : " + _toDisplayString(_ctx.newCommonFormatCurrency(
                                                        _ctx.onlyManualOdsFromBalances695,
                                                    )), 1),
                                      _createElementVNode("td", _hoisted_77, " OD générée : " + _toDisplayString(_ctx.newCommonFormatCurrency(
                                                        _ctx.onlyAcrResultsFromBalance695,
                                                    )), 1),
                                      _cache[112] || (_cache[112] = _createElementVNode("td", {
                                        width: "10%",
                                        class: "text-right"
                                      }, null, -1)),
                                      _createElementVNode("td", _hoisted_78, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                        _ctx.auditItems.corporateTaxFromBalances695,
                                                        undefined,
                                                    )), 1)
                                    ]),
                                    (_ctx.c695gap)
                                      ? (_openBlock(), _createElementBlock("tr", _hoisted_79, [
                                          _cache[113] || (_cache[113] = _createElementVNode("td", {
                                            width: "50%",
                                            class: "pl-8",
                                            colspan: "2"
                                          }, " Ecart entre le solde de la balance c/695 et l'impôt dû ", -1)),
                                          _createElementVNode("td", _hoisted_80, " (OD à régénérer : " + _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.toBeBooked)) + ") ", 1),
                                          _cache[114] || (_cache[114] = _createElementVNode("td", {
                                            width: "10%",
                                            class: "text-right"
                                          }, null, -1)),
                                          _createElementVNode("td", _hoisted_81, _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.c695gap, undefined)), 1)
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("td", _hoisted_82, _toDisplayString(_ctx.$t(
                                                        "audit." +
                                                            _ctx.key +
                                                            ".previousCreditsAllocation",
                                                    )), 1),
                                      _cache[116] || (_cache[116] = _createElementVNode("td", { width: "20%" }, null, -1)),
                                      _cache[117] || (_cache[117] = _createElementVNode("td", { width: "20%" }, null, -1)),
                                      _createElementVNode("td", _hoisted_83, [
                                        _createElementVNode("div", null, [
                                          _createVNode(_component_v_btn_icon, {
                                            icon: " $oss-help",
                                            onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.previousPaymentsSnackbar = true))
                                          }),
                                          _createVNode(_component_v_snackbar, {
                                            modelValue: _ctx.previousPaymentsSnackbar,
                                            "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.previousPaymentsSnackbar) = $event)),
                                            "min-width": "50vw"
                                          }, {
                                            actions: _withCtx(() => [
                                              _createVNode(_component_v_btn_icon, {
                                                icon: "$oss-close",
                                                size: "small",
                                                onClick: _cache[29] || (_cache[29] = _withModifiers(($event: any) => (
                                                                    _ctx.previousPaymentsSnackbar = false
                                                                ), ["stop"])),
                                                class: "white"
                                              })
                                            ]),
                                            default: _withCtx(() => [
                                              _cache[115] || (_cache[115] = _createElementVNode("h2", { class: "pb-2" }, " Montant manuel à analyser dans le grand livre c/444000 ", -1))
                                            ]),
                                            _: 1
                                          }, 8, ["modelValue"])
                                        ])
                                      ]),
                                      (
                                                    _ctx.auditItems.validatedTax &&
                                                    _ctx.auditItems.previousCreditsAllocation
                                                )
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_84, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                        _ctx.auditItems.previousCreditsAllocation,
                                                        { currency: "", DC: true },
                                                    )), 1))
                                        : (_ctx.auditItems.validatedTax)
                                          ? (_openBlock(), _createElementBlock("td", _hoisted_85, _toDisplayString(_ctx.newCommonFormatCurrency(0, {
                                                        currency: "",
                                                        DC: true,
                                                    })), 1))
                                          : (_openBlock(), _createElementBlock("td", _hoisted_86, [
                                              _createVNode(_component_oss_text_field, {
                                                modelValue: _ctx.auditItems.previousCreditsAllocation,
                                                "onUpdate:modelValue": [
                                                  _cache[31] || (_cache[31] = ($event: any) => ((_ctx.auditItems.previousCreditsAllocation) = $event)),
                                                  _cache[32] || (_cache[32] = ($event: any) => (_ctx.changeAmounts()))
                                                ],
                                                disabled: _ctx.closedPeriod,
                                                outlined: "",
                                                dense: "",
                                                "hide-details": "",
                                                style: {"width":"250px"},
                                                suffix: "€"
                                              }, null, 8, ["modelValue", "disabled"])
                                            ]))
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("td", _hoisted_87, _toDisplayString(_ctx.$t("audit." + _ctx.key + ".onAccountPayments")), 1),
                                      _cache[119] || (_cache[119] = _createElementVNode("td", { width: "20%" }, null, -1)),
                                      _cache[120] || (_cache[120] = _createElementVNode("td", { width: "20%" }, null, -1)),
                                      _createElementVNode("td", _hoisted_88, [
                                        _createElementVNode("div", null, [
                                          _createVNode(_component_v_btn_icon, {
                                            icon: " $oss-help",
                                            onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.previousPaymentsSnackbar = true))
                                          }),
                                          _createVNode(_component_v_snackbar, {
                                            modelValue: _ctx.previousPaymentsSnackbar,
                                            "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.previousPaymentsSnackbar) = $event)),
                                            "min-width": "50vw"
                                          }, {
                                            actions: _withCtx(() => [
                                              _createVNode(_component_v_btn_icon, {
                                                icon: "$oss-close",
                                                size: "small",
                                                onClick: _cache[34] || (_cache[34] = _withModifiers(($event: any) => (
                                                                    _ctx.previousPaymentsSnackbar = false
                                                                ), ["stop"])),
                                                class: "white"
                                              })
                                            ]),
                                            default: _withCtx(() => [
                                              _cache[118] || (_cache[118] = _createElementVNode("h2", { class: "pb-2" }, " Montant manuel à analyser dans le grand livre c/444000 ", -1))
                                            ]),
                                            _: 1
                                          }, 8, ["modelValue"])
                                        ])
                                      ]),
                                      (
                                                    _ctx.auditItems.validatedTax &&
                                                    _ctx.auditItems.onAccountPayments
                                                )
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_89, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                        _ctx.auditItems.onAccountPayments,
                                                        { currency: "", DC: true },
                                                    )), 1))
                                        : (_ctx.auditItems.validatedTax)
                                          ? (_openBlock(), _createElementBlock("td", _hoisted_90, _toDisplayString(_ctx.newCommonFormatCurrency(0, {
                                                        currency: "",
                                                        DC: true,
                                                    })), 1))
                                          : (_openBlock(), _createElementBlock("td", _hoisted_91, [
                                              _createVNode(_component_oss_text_field, {
                                                outlined: "",
                                                dense: "",
                                                "hide-details": "",
                                                style: {"width":"250px"},
                                                suffix: "€",
                                                modelValue: _ctx.auditItems.onAccountPayments,
                                                "onUpdate:modelValue": [
                                                  _cache[36] || (_cache[36] = ($event: any) => ((_ctx.auditItems.onAccountPayments) = $event)),
                                                  _cache[37] || (_cache[37] = ($event: any) => (_ctx.changeAmounts()))
                                                ],
                                                disabled: _ctx.closedPeriod
                                              }, null, 8, ["modelValue", "disabled"])
                                            ]))
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("td", _hoisted_92, _toDisplayString(_ctx.$t("audit." + _ctx.key + ".miscellanousTaxCredits")), 1),
                                      _cache[122] || (_cache[122] = _createElementVNode("td", { width: "20%" }, null, -1)),
                                      _cache[123] || (_cache[123] = _createElementVNode("td", { width: "20%" }, null, -1)),
                                      _createElementVNode("td", _hoisted_93, [
                                        _createElementVNode("div", null, [
                                          _createVNode(_component_v_btn_icon, {
                                            icon: " $oss-help",
                                            onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.previousPaymentsSnackbar = true))
                                          }),
                                          _createVNode(_component_v_snackbar, {
                                            modelValue: _ctx.previousPaymentsSnackbar,
                                            "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.previousPaymentsSnackbar) = $event)),
                                            "min-width": "50vw"
                                          }, {
                                            actions: _withCtx(() => [
                                              _createVNode(_component_v_btn_icon, {
                                                icon: "$oss-close",
                                                size: "small",
                                                onClick: _cache[39] || (_cache[39] = _withModifiers(($event: any) => (
                                                                    _ctx.previousPaymentsSnackbar = false
                                                                ), ["stop"])),
                                                class: "white"
                                              })
                                            ]),
                                            default: _withCtx(() => [
                                              _cache[121] || (_cache[121] = _createElementVNode("h2", { class: "pb-2" }, " Montant manuel à analyser dans le grand livre c/444000 ", -1))
                                            ]),
                                            _: 1
                                          }, 8, ["modelValue"])
                                        ])
                                      ]),
                                      (
                                                    _ctx.auditItems.validatedTax &&
                                                    _ctx.auditItems.miscellanousTaxCredits
                                                )
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_94, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                        _ctx.auditItems.miscellanousTaxCredits,
                                                        { currency: "", DC: true },
                                                    )), 1))
                                        : (_ctx.auditItems.validatedTax)
                                          ? (_openBlock(), _createElementBlock("td", _hoisted_95, _toDisplayString(_ctx.newCommonFormatCurrency(0, {
                                                        currency: "",
                                                        DC: true,
                                                    })), 1))
                                          : (_openBlock(), _createElementBlock("td", _hoisted_96, [
                                              _createVNode(_component_oss_text_field, {
                                                outlined: "",
                                                dense: "",
                                                "hide-details": "",
                                                style: {"width":"250px"},
                                                suffix: "€",
                                                modelValue: _ctx.auditItems.miscellanousTaxCredits,
                                                "onUpdate:modelValue": [
                                                  _cache[41] || (_cache[41] = ($event: any) => ((_ctx.auditItems.miscellanousTaxCredits) = $event)),
                                                  _cache[42] || (_cache[42] = ($event: any) => (_ctx.changeAmounts()))
                                                ],
                                                disabled: _ctx.closedPeriod,
                                                "data-cy": "CheckCorporateTax-auditItemsMiscellanousTaxCredits"
                                              }, null, 8, ["modelValue", "disabled"])
                                            ]))
                                    ]),
                                    _createElementVNode("tr", _hoisted_97, [
                                      (_ctx.toBePaid >= 0)
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_98, " Reste à payer "))
                                        : (_openBlock(), _createElementBlock("td", _hoisted_99, " Crédit d'IS à reporter ")),
                                      _cache[125] || (_cache[125] = _createElementVNode("td", { width: "20%" }, null, -1)),
                                      _cache[126] || (_cache[126] = _createElementVNode("td", { width: "20%" }, null, -1)),
                                      _createElementVNode("td", _hoisted_100, [
                                        _createElementVNode("div", null, [
                                          _createVNode(_component_v_btn_icon, {
                                            icon: " $oss-help",
                                            onClick: _cache[43] || (_cache[43] = ($event: any) => (_ctx.toBePaidSnackbar = true))
                                          }),
                                          _createVNode(_component_v_snackbar, {
                                            modelValue: _ctx.toBePaidSnackbar,
                                            "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.toBePaidSnackbar) = $event)),
                                            "min-width": "50vw"
                                          }, {
                                            actions: _withCtx(() => [
                                              _createVNode(_component_v_btn_icon, {
                                                icon: "$oss-close",
                                                size: "small",
                                                onClick: _cache[44] || (_cache[44] = _withModifiers(($event: any) => (
                                                                    _ctx.toBePaidSnackbar = false
                                                                ), ["stop"])),
                                                class: "white"
                                              })
                                            ]),
                                            default: _withCtx(() => [
                                              _cache[124] || (_cache[124] = _createElementVNode("h2", { class: "pb-2" }, " Eventuelle régularisation à comptabiliser, par rapport au solde de la balance ", -1))
                                            ]),
                                            _: 1
                                          }, 8, ["modelValue"])
                                        ])
                                      ]),
                                      _createElementVNode("td", _hoisted_101, _toDisplayString(_ctx.newCommonFormatCurrency(Math.abs(_ctx.toBePaid), {
                                                        currency: "",
                                                        DC: true,
                                                    })), 1)
                                    ])
                                  ])
                                ]),
                                _: 1
                              }, 8, ["class"]),
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                class: "text-right pt-4"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_spacer),
                                  _createVNode(_component_v_col, {
                                    cols: "auto",
                                    class: "text-right pr-4"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_btn, {
                                        disabled: _ctx.closedPeriod || _ctx.auditItems.validated,
                                        dense: "",
                                        rounded: "",
                                        elevation: "0",
                                        onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.storeReinstatementsAndDeductions())),
                                        size: "small"
                                      }, {
                                        default: _withCtx(() => _cache[127] || (_cache[127] = [
                                          _createTextVNode(" Enregistrer ")
                                        ])),
                                        _: 1
                                      }, 8, ["disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, {
                                    cols: "auto",
                                    class: "text-right"
                                  }, {
                                    default: _withCtx(() => [
                                      (!_ctx.auditItems.validatedTax)
                                        ? (_openBlock(), _createBlock(_component_v_btn, {
                                            key: 0,
                                            disabled: _ctx.closedPeriod || _ctx.auditItems.validated,
                                            dense: "",
                                            rounded: "",
                                            elevation: "0",
                                            onClick: _cache[47] || (_cache[47] = ($event: any) => {
                                                _ctx.auditItems.validatedTax = true;
                                                _ctx.showComments = true;
                                                _ctx.showTax = false;
                                                _ctx.storeReinstatementsAndDeductions('VALIDATE');
                                            }),
                                            size: "small"
                                          }, {
                                            default: _withCtx(() => _cache[128] || (_cache[128] = [
                                              _createTextVNode(" Valider le calcul d'impôt sur les sociétés ")
                                            ])),
                                            _: 1
                                          }, 8, ["disabled"]))
                                        : (_openBlock(), _createBlock(_component_v_btn, {
                                            key: 1,
                                            disabled: _ctx.closedPeriod || _ctx.auditItems.validated,
                                            dense: "",
                                            rounded: "",
                                            elevation: "0",
                                            onClick: _cache[48] || (_cache[48] = ($event: any) => {
                                                _ctx.auditItems.validatedTax = false;
                                                _ctx.storeReinstatementsAndDeductions('UPDATE');
                                            }),
                                            size: "small"
                                          }, {
                                            default: _withCtx(() => _cache[129] || (_cache[129] = [
                                              _createTextVNode(" Invalider le calcul d'impôt sur les sociétés ")
                                            ])),
                                            _: 1
                                          }, 8, ["disabled"]))
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ], 512), [
                          [_vShow, _ctx.showTax]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card, { class: "audit-card" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "11",
                          class: "ma-auto"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                              default: _withCtx(() => [
                                _createElementVNode("h5", _hoisted_102, _toDisplayString(_ctx.$t("audit." + _ctx.key + ".resume")), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "1",
                          class: "d-flex align-center px-0 justify-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "6" }),
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "align-center pa-0"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_btn_icon, {
                                      icon: _ctx.showComments ? '$fa-chevron-up' : '$fa-chevron-down',
                                      onClick: _cache[49] || (_cache[49] = ($event: any) => (_ctx.showComments = !_ctx.showComments)),
                                      style: {"width":"40px"},
                                      class: "d-inline px-2"
                                    }, null, 8, ["icon"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_expand_transition, null, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("div", null, [
                          _createVNode(_component_v_row, { style: {"padding-left":"0","padding-right":"0"} }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, { style: {"padding-top":"0","padding-bottom":"0"} }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_card_text, {
                                    style: {"background-color":"white","border-radius":"25px"},
                                    class: "mb-4"
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.auditItems.comments, (comment, index) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: index,
                                          class: "py-2"
                                        }, [
                                          _createElementVNode("h3", _hoisted_103, _toDisplayString(comment.subtitle), 1),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.toArray(
                                                    comment.comment,
                                                ), (commentLine, ic) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: ic,
                                              class: "mb-0"
                                            }, [
                                              _createElementVNode("p", _hoisted_104, _toDisplayString(commentLine), 1)
                                            ]))
                                          }), 128))
                                        ]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ], 512), [
                          [_vShow, _ctx.showComments]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (!_ctx.loading && !_ctx.dataLoading)
                  ? (_openBlock(), _createBlock(_component_AuditConnectedAcrDocuments, {
                      key: 3,
                      connectedDocuments: _ctx.connectedDocuments,
                      companyId: _ctx.companyId,
                      acKey: _ctx.key,
                      auditCheckResult: _ctx.auditCheckResult || {},
                      accountingPeriodId: _ctx.accountingPeriodId || undefined,
                      onUnlinkedDocument: _cache[50] || (_cache[50] = ($event: any) => (_ctx.unlinkDocument($event))),
                      onShowLinkedDocument: _cache[51] || (_cache[51] = ($event: any) => (_ctx.showLinkedDocument($event)))
                    }, null, 8, ["connectedDocuments", "companyId", "acKey", "auditCheckResult", "accountingPeriodId"]))
                  : _createCommentVNode("", true),
                (!_ctx.loading && !_ctx.dataLoading)
                  ? (_openBlock(), _createBlock(_component_AuditConnectedAcrResults, {
                      key: 4,
                      results: _ctx.results,
                      companyId: _ctx.companyId
                    }, null, 8, ["results", "companyId"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_card, { class: "audit-card" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "11",
                          class: "ma-auto"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                              default: _withCtx(() => _cache[130] || (_cache[130] = [
                                _createElementVNode("h5", { class: "pl-4" }, "Commentaires détaillés", -1)
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "1",
                          class: "d-flex align-center px-0 justify-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "6" }),
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "align-center pa-0"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_btn_icon, {
                                      icon: 
                                            _ctx.showLongComment ? '$fa-chevron-up' : '$fa-chevron-down'
                                        ,
                                      onClick: _cache[52] || (_cache[52] = ($event: any) => (_ctx.showLongComment = !_ctx.showLongComment)),
                                      style: {"width":"40px"},
                                      class: "d-inline px-2"
                                    }, null, 8, ["icon"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_expand_transition, { "no-gutters": "" }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("div", _hoisted_105, [
                          _createVNode(_component_v_card_text, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_textarea, {
                                modelValue: _ctx.auditItems.longComment,
                                "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.auditItems.longComment) = $event)),
                                disabled: _ctx.closedPeriod || (_ctx.auditItems && _ctx.auditItems.validated),
                                "auto-grow": "",
                                class: "pt-1",
                                style: {"border":"1px #ededed solid"},
                                outlined: ""
                              }, null, 8, ["modelValue", "disabled"]),
                              _createVNode(_component_v_row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_spacer),
                                  _createVNode(_component_v_col, {
                                    cols: "auto",
                                    class: "pt-6"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_row, { class: "text-right" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, {
                                            cols: "auto",
                                            class: "text-right"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_btn, {
                                                disabled: _ctx.closedPeriod || _ctx.auditItems.validated,
                                                rounded: "",
                                                elevation: "0",
                                                onClick: _cache[54] || (_cache[54] = ($event: any) => (_ctx.storeReinstatementsAndDeductions())),
                                                size: "small"
                                              }, {
                                                default: _withCtx(() => _cache[131] || (_cache[131] = [
                                                  _createTextVNode(" Enregistrer ")
                                                ])),
                                                _: 1
                                              }, 8, ["disabled"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ], 512), [
                          [_vShow, _ctx.showLongComment]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card, { class: "audit-card" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "11",
                          class: "ma-auto"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                              default: _withCtx(() => _cache[132] || (_cache[132] = [
                                _createElementVNode("h5", { class: "pl-4" }, "Commentaires synthétiques", -1)
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "1",
                          class: "d-flex align-center px-0 justify-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "6" }),
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "align-center pa-0"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_btn_icon, {
                                      icon: 
                                            _ctx.showShortComment ? '$fa-chevron-up' : '$fa-chevron-down'
                                        ,
                                      onClick: _cache[55] || (_cache[55] = ($event: any) => (_ctx.showShortComment = !_ctx.showShortComment)),
                                      style: {"width":"40px"},
                                      class: "d-inline px-2"
                                    }, null, 8, ["icon"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_expand_transition, { "no-gutters": "" }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("div", _hoisted_106, [
                          _createVNode(_component_v_card_text, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_textarea, {
                                modelValue: _ctx.auditItems.shortComment,
                                "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.auditItems.shortComment) = $event)),
                                disabled: _ctx.closedPeriod || (_ctx.auditItems && _ctx.auditItems.validated),
                                "auto-grow": "",
                                style: {"border":"1px #ededed solid"},
                                outlined: ""
                              }, null, 8, ["modelValue", "disabled"]),
                              _createVNode(_component_v_row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_spacer),
                                  _createVNode(_component_v_col, {
                                    cols: "auto",
                                    class: "pt-6"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_row, { class: "text-right" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, {
                                            cols: "auto",
                                            class: "text-right"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_btn, {
                                                disabled: _ctx.closedPeriod || _ctx.auditItems.validated,
                                                rounded: "",
                                                elevation: "0",
                                                onClick: _cache[57] || (_cache[57] = ($event: any) => (_ctx.storeReinstatementsAndDeductions())),
                                                size: "small"
                                              }, {
                                                default: _withCtx(() => _cache[133] || (_cache[133] = [
                                                  _createTextVNode(" Enregistrer ")
                                                ])),
                                                _: 1
                                              }, 8, ["disabled"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ], 512), [
                          [_vShow, _ctx.showShortComment]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card, { class: "audit-card" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "11",
                          class: "ma-auto"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                              default: _withCtx(() => [
                                _createElementVNode("h5", _hoisted_107, _toDisplayString(_ctx.$t("audit." + _ctx.key + ".balance_generalLedger") +
                                        " " +
                                        _ctx.getTextFromStringArray(
                                            _ctx.auditItems.auditReportAccountableAccounts,
                                        )), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "1",
                          class: "d-flex align-center px-0 justify-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "6" }),
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "align-center pa-0"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_btn_icon, {
                                      icon: 
                                            _ctx.showGeneralLedger
                                                ? '$fa-chevron-up'
                                                : '$fa-chevron-down'
                                        ,
                                      onClick: _cache[58] || (_cache[58] = ($event: any) => (_ctx.showGeneralLedger = !_ctx.showGeneralLedger)),
                                      style: {"width":"40px"},
                                      class: "d-inline px-2"
                                    }, null, 8, ["icon"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_expand_transition, null, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("div", null, [
                          _createVNode(_component_v_row, { class: "pt-2" }, {
                            default: _withCtx(() => [
                              (_openBlock(), _createBlock(_component_v_col, {
                                style: {"padding-top":"0","padding-bottom":"0"},
                                key: _ctx.refreshGeneralLedger
                              }, {
                                default: _withCtx(() => [
                                  (_ctx.accountingPeriod)
                                    ? (_openBlock(), _createBlock(_component_GeneralLedger, {
                                        key: 0,
                                        companyId: _ctx.companyId,
                                        accountingPeriodId: _ctx.accountingPeriod.id,
                                        accountableAccountFilter: 
                                            _ctx.auditItems.auditReportAccountableAccounts
                                        ,
                                        onQueryDone: _ctx.onQueryDone
                                      }, null, 8, ["companyId", "accountingPeriodId", "accountableAccountFilter", "onQueryDone"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }))
                            ]),
                            _: 1
                          })
                        ], 512), [
                          [_vShow, _ctx.showGeneralLedger]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (_ctx.detailsDialog)
                  ? (_openBlock(), _createBlock(_component_oss_dialog, {
                      key: 5,
                      modelValue: _ctx.detailsDialog,
                      "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((_ctx.detailsDialog) = $event)),
                      width: "90vw",
                      class: "justify-space-around",
                      title: _ctx.detailsDialogTitle,
                      onValid: _cache[62] || (_cache[62] = ($event: any) => (_ctx.addComment(_ctx.adjustmentTable[_ctx.atIndex]))),
                      onClose: _ctx.quitDetailsDialog,
                      validTitle: _ctx.$t('audit.' + _ctx.key + '.saveComments'),
                      validDisabled: !(_ctx.adjustmentTable && _ctx.atIndex && _ctx.adjustmentTable[_ctx.atIndex])
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_window, {
                          modelValue: _ctx.step,
                          "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((_ctx.step) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_window_item, { value: 1 }, {
                              default: _withCtx(() => [
                                (_openBlock(), _createElementBlock("div", { key: _ctx.refreshDetailsGeneralLedger }, [
                                  (_ctx.accountingPeriod)
                                    ? (_openBlock(), _createBlock(_component_GeneralLedger, {
                                        key: 0,
                                        companyId: _ctx.companyId,
                                        accountingPeriodId: _ctx.accountingPeriodId,
                                        accountableAccountFilter: _ctx.glAccountableAccountsRoot,
                                        hideOptions: true,
                                        hideBodyAppend: "true",
                                        onQueryDone: _ctx.onDetailsQueryDone
                                      }, null, 8, ["companyId", "accountingPeriodId", "accountableAccountFilter", "onQueryDone"]))
                                    : _createCommentVNode("", true)
                                ])),
                                _createVNode(_component_v_row, {
                                  "no-gutters": "",
                                  class: "pt-4 pb-2"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, null, {
                                      default: _withCtx(() => _cache[134] || (_cache[134] = [
                                        _createElementVNode("h3", null, "Commentaire", -1)
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { style: {"padding-top":"0","padding-bottom":"0"} }, {
                                      default: _withCtx(() => [
                                        (
                                            _ctx.adjustmentTable && _ctx.atIndex && _ctx.adjustmentTable[_ctx.atIndex]
                                        )
                                          ? (_openBlock(), _createBlock(_component_v_textarea, {
                                              key: 0,
                                              style: {"padding-left":"0","padding-right":"0","border":"1px #ededed solid"},
                                              disabled: 
                                            _ctx.closedPeriod || (_ctx.auditItems && _ctx.auditItems.validated)
                                        ,
                                              modelValue: _ctx.adjustmentTable[_ctx.atIndex].comment,
                                              "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.adjustmentTable[_ctx.atIndex].comment) = $event)),
                                              "auto-grow": "",
                                              outlined: ""
                                            }, null, 8, ["disabled", "modelValue"]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "title", "onClose", "validTitle", "validDisabled"]))
                  : _createCommentVNode("", true),
                (_ctx.regenerateBundleDialog)
                  ? (_openBlock(), _createBlock(_component_oss_dialog, {
                      key: 6,
                      modelValue: _ctx.regenerateBundleDialog,
                      "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((_ctx.regenerateBundleDialog) = $event)),
                      title: "Mise à jour à faire",
                      "valid-title": "Aller à la page de la liasse fiscale",
                      onValid: _cache[64] || (_cache[64] = ($event: any) => {
                        _ctx.regenerateBundleDialog = false;
                        _ctx.$router.push(_ctx.auditItems.bundleErrorMessage.path);
                    }),
                      onClose: _cache[65] || (_cache[65] = ($event: any) => (_ctx.regenerateBundleDialog = false)),
                      "min-width": "60vw"
                    }, {
                      default: _withCtx(() => [
                        (
                            _ctx.auditItems.bundleErrorMessage && _ctx.auditItems.bundleErrorMessage.message
                        )
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              innerHTML: _ctx.auditItems.bundleErrorMessage.message
                            }, null, 8, _hoisted_108))
                          : (_openBlock(), _createElementBlock("p", _hoisted_109, " Le grand livre a été modifié. Veuillez recalculer la liasse fiscale ou créer une liasse rectificative. "))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]))
                  : _createCommentVNode("", true),
                (_ctx.generateNewBundleDialog)
                  ? (_openBlock(), _createBlock(_component_oss_dialog, {
                      key: 7,
                      modelValue: _ctx.generateNewBundleDialog,
                      "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((_ctx.generateNewBundleDialog) = $event)),
                      title: "Aucune liasse fiscale enregistrée",
                      "valid-title": "Ouvrir une nouvelle liasse fiscale",
                      onValid: _cache[67] || (_cache[67] = ($event: any) => {
                        _ctx.generateNewBundleDialog = false;
                        _ctx.$router.push({ name: 'taxForm2-new' });
                    }),
                      onClose: _cache[68] || (_cache[68] = ($event: any) => (_ctx.generateNewBundleDialog = false)),
                      "min-width": "60vw"
                    }, {
                      default: _withCtx(() => _cache[135] || (_cache[135] = [
                        _createElementVNode("p", { class: "text-center" }, " Ce contrôle se base sur les données contenues dans la liasse fiscale. ", -1)
                      ])),
                      _: 1
                    }, 8, ["modelValue"]))
                  : _createCommentVNode("", true),
                (_ctx.displayActivityDialog)
                  ? (_openBlock(), _createBlock(_component_oss_dialog, {
                      key: 8,
                      modelValue: _ctx.displayActivityDialog,
                      "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => ((_ctx.displayActivityDialog) = $event)),
                      title: "Activité",
                      "valid-title": "Fermer",
                      onValid: _cache[70] || (_cache[70] = ($event: any) => (_ctx.displayActivityDialog = false)),
                      onClose: _cache[71] || (_cache[71] = ($event: any) => (_ctx.displayActivityDialog = false)),
                      "min-width": "60vw"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_UsersActivitiesHistory, {
                          auditCheckKey: _ctx.acKey,
                          accountingPeriodId: _ctx.accountingPeriodId
                        }, null, 8, ["auditCheckKey", "accountingPeriodId"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]))
                  : _createCommentVNode("", true),
                (_ctx.deleteAuditCheckResultDialog)
                  ? (_openBlock(), _createBlock(_component_AuditDeleteAuditCheckResultDialog, {
                      key: 9,
                      modelValue: _ctx.deleteAuditCheckResultDialog,
                      "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event: any) => ((_ctx.deleteAuditCheckResultDialog) = $event)),
                      auditCheckResultId: _ctx.auditCheckResult.id,
                      onClosed: _cache[73] || (_cache[73] = ($event: any) => {
                            _ctx.deleteAuditCheckResultLoading = false;
                            _ctx.deleteAuditCheckResultDialog = false;
                        }),
                      onDeletedAcr: _ctx.deleteAcrDone
                    }, null, 8, ["modelValue", "auditCheckResultId", "onDeletedAcr"]))
                  : _createCommentVNode("", true),
                (_ctx.openChat)
                  ? (_openBlock(), _createBlock(_component_Chat, {
                      key: 10,
                      auditCheckAccountingPeriodKey: _ctx.chatId,
                      chatTitle: 'Chat'
                    }, null, 8, ["auditCheckAccountingPeriodKey"]))
                  : _createCommentVNode("", true),
                (_ctx.dialogAuditCheckDocumentsManager)
                  ? (_openBlock(), _createBlock(_component_AuditCheckDocumentsManager, {
                      key: 11,
                      modelValue: _ctx.dialogAuditCheckDocumentsManager,
                      "onUpdate:modelValue": _cache[74] || (_cache[74] = ($event: any) => ((_ctx.dialogAuditCheckDocumentsManager) = $event)),
                      disabled: _ctx.loading || _ctx.dataLoading || !_ctx.accountingPeriod,
                      companyId: _ctx.companyId,
                      documentToDisplay: _ctx.documentToDisplay,
                      connectedDocuments: _ctx.connectedDocuments || [],
                      acKey: _ctx.key,
                      auditCheckResult: _ctx.auditCheckResult || {},
                      accountingPeriodId: _ctx.accountingPeriodId || undefined,
                      alreadyLinkedDoc: _ctx.alreadyLinkedDoc,
                      onUpsertedAuditCheckResult: _ctx.upsertedACR,
                      onResetDialogData: _cache[75] || (_cache[75] = ($event: any) => {
                        _ctx.alreadyLinkedDoc = false;
                        _ctx.documentToDisplay = {};
                    })
                    }, null, 8, ["modelValue", "disabled", "companyId", "documentToDisplay", "connectedDocuments", "acKey", "auditCheckResult", "accountingPeriodId", "alreadyLinkedDoc", "onUpsertedAuditCheckResult"]))
                  : _createCommentVNode("", true)
              ], 64))
      ])
    ]),
    _: 1
  }))
}